<nb-card class="no-edge-card mb-0 detalle-grupo-card">
	<div class="closeModal">
		<nb-icon class="m-1" icon="close-circle" [options]="{ animation: { type: 'zoom' } }" (click)="closeModal()"
			nbTooltip="Cerrar" nbTooltipPlacement="left">
		</nb-icon>
	</div>

	<nb-card-header class="border-bottom-0 detalle-header">
		<div class="d-flex align-items-center justify-content-between flex-wrap gap-3">
			<div class="d-flex align-items-center gap-3">
				<nb-icon icon="people-outline" class="header-icon"></nb-icon>
				<div>
					<h4 class="m-0 header-title">{{group?.title}}</h4>
					<small class="header-subtitle">Estudio Científico - Detalle del Grupo</small>
				</div>
			</div>
			<div class="stats-container">
				<div class="stat-item">
					<span class="stat-value">{{group?.assignedStudents ?? 0}}</span>
					<span class="stat-label">Estudiantes</span>
				</div>
				<div class="stat-item">
					<span class="stat-value">{{profesores.length}}</span>
					<span class="stat-label">Profesores</span>
				</div>
				<div class="stat-item">
					<span class="stat-value">{{mandos.length}}</span>
					<span class="stat-label">Mandos</span>
				</div>
			</div>
		</div>
	</nb-card-header>

	<div class="tabs-container">
		<div class="tab-buttons">
			<button class="tab-btn" [class.active]="activeTab === 'informes'" (click)="setTab('informes')">
				<nb-icon icon="file-text-outline"></nb-icon>
				Informes
			</button>
			<button class="tab-btn" [class.active]="activeTab === 'dashboard'" (click)="setTab('dashboard')">
				<nb-icon icon="bar-chart-outline"></nb-icon>
				Dashboard
			</button>
			<button class="tab-btn" [class.active]="activeTab === 'profesores'" (click)="setTab('profesores')">
				<nb-icon icon="person-outline"></nb-icon>
				Profesores
			</button>
			<button class="tab-btn" [class.active]="activeTab === 'mandos'" (click)="setTab('mandos')">
				<nb-icon icon="keypad-outline"></nb-icon>
				Mandos
			</button>
		</div>
	</div>

	<nb-card-body class="p-0">
		<!-- Tab: Informes -->
		<div *ngIf="activeTab === 'informes'">
			<div class="informes-container">
				<div class="informes-action">
					<nb-icon icon="bar-chart-outline" class="informes-icon"></nb-icon>
					<h5>Informes del Grupo</h5>
					<p>Visualiza los informes de actividad, progreso y resultados de este grupo.</p>
					<button nbButton status="primary" (click)="abrirInformes()">
						<nb-icon icon="eye-outline"></nb-icon>
						Ver Informes
					</button>
				</div>
				<div class="grupo-info">
					<div class="info-row" *ngIf="group?.nivel">
						<span class="info-label">Nivel:</span>
						<span class="info-value">{{group.nivel}}</span>
					</div>
					<div class="info-row" *ngIf="group?.letras">
						<span class="info-label">Letras:</span>
						<span class="info-value">{{group.letras}}</span>
					</div>
					<div class="info-row">
						<span class="info-label">Cursos asignados:</span>
						<span class="info-value">{{group?.assignedProjects ?? 0}}</span>
					</div>
					<div class="info-row">
						<span class="info-label">Estudiantes:</span>
						<span class="info-value">{{group?.assignedStudents ?? 0}}</span>
					</div>
				</div>
			</div>
		</div>

		<!-- Tab: Dashboard -->
		<div *ngIf="activeTab === 'dashboard'">
			<app-dashboard-estudio
				[level]="'group'"
				[idGroup]="group?.idGroup">
			</app-dashboard-estudio>
		</div>

		<!-- Tab: Profesores -->
		<div *ngIf="activeTab === 'profesores'">
			<div class="table-container" *ngIf="!loadingProfesores; else loadingTpl">
				<nb-form-field class="table-search-field" *ngIf="profesores.length > 0">
					<nb-icon nbPrefix icon="search-outline"></nb-icon>
					<input nbInput type="text" placeholder="Buscar..." [(ngModel)]="searchProfesores">
				</nb-form-field>
				<table class="detalle-table" *ngIf="profesores.length > 0; else emptyProfesoresTpl">
					<thead>
						<tr>
							<th class="sortable" (click)="sortProfesores('name')">Nombre <span class="sort-icon">{{ getProfesoresSortIcon('name') }}</span></th>
							<th class="sortable" (click)="sortProfesores('surname')">Apellido <span class="sort-icon">{{ getProfesoresSortIcon('surname') }}</span></th>
							<th class="sortable" (click)="sortProfesores('email')">Email <span class="sort-icon">{{ getProfesoresSortIcon('email') }}</span></th>
							<th class="text-right">Acciones</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let profesor of profesoresFiltrados">
							<td class="font-weight-bold">{{profesor.firstName || profesor.name || '—'}}</td>
							<td>{{profesor.surname || profesor.surName || '—'}}</td>
							<td>{{profesor.mail || profesor.email || '—'}}</td>
							<td class="text-right">
								<button nbButton size="small" status="primary" ghost
										nbTooltip="Ver dashboard del profesor"
										(click)="abrirDashboardProfesor(profesor)">
									<nb-icon icon="bar-chart-outline"></nb-icon>
								</button>
							</td>
						</tr>
					</tbody>
				</table>
				<ng-template #emptyProfesoresTpl>
					<div class="empty-state">
						<nb-icon icon="person-outline" class="empty-icon"></nb-icon>
						<p>No se encontraron profesores asociados a este grupo</p>
					</div>
				</ng-template>
			</div>
		</div>

		<!-- Tab: Mandos -->
		<div *ngIf="activeTab === 'mandos'">
			<div class="table-container" *ngIf="!loadingMandos; else loadingTpl">
				<nb-form-field class="table-search-field" *ngIf="mandos.length > 0">
					<nb-icon nbPrefix icon="search-outline"></nb-icon>
					<input nbInput type="text" placeholder="Buscar..." [(ngModel)]="searchMandos">
				</nb-form-field>
				<table class="detalle-table" *ngIf="mandos.length > 0; else emptyMandosTpl">
					<thead>
						<tr>
							<th class="sortable" (click)="sortMandos('idMando')">ID Mando <span class="sort-icon">{{ getMandosSortIcon('idMando') }}</span></th>
							<th class="sortable" (click)="sortMandos('mac')">MAC <span class="sort-icon">{{ getMandosSortIcon('mac') }}</span></th>
							<th class="sortable" (click)="sortMandos('estado')">Estado <span class="sort-icon">{{ getMandosSortIcon('estado') }}</span></th>
							<th class="sortable" (click)="sortMandos('battery')">Batería <span class="sort-icon">{{ getMandosSortIcon('battery') }}</span></th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let mando of mandosFiltrados">
							<td class="font-weight-bold">{{mando.idMando}}</td>
							<td>{{mando.mac || '—'}}</td>
							<td>
								<span class="estado-badge" [ngClass]="getEstadoClass(mando.estado)">
									{{getEstadoLabel(mando.estado)}}
								</span>
							</td>
							<td>{{mando.battery != null ? mando.battery + '%' : '—'}}</td>
						</tr>
					</tbody>
				</table>
				<ng-template #emptyMandosTpl>
					<div class="empty-state">
						<nb-icon icon="keypad-outline" class="empty-icon"></nb-icon>
						<p>No se encontraron mandos asociados a este grupo</p>
					</div>
				</ng-template>
			</div>
		</div>

		<ng-template #loadingTpl>
			<div class="loading-state">
				<nb-spinner status="primary" size="large"></nb-spinner>
			</div>
		</ng-template>
	</nb-card-body>
</nb-card>
